<div class="pds-switch-container" (click)="toggle()">
  <input type="checkbox" [checked]="value" [disabled]="disabled || false" />
  <span class="switch"></span>
  <ng-container *ngIf="label">
    <label>{{ label }}</label>
  </ng-container>
</div>
